import React from 'react';
import { common } from '@kurtosys/ksys-app-template';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import Translate from '../Translate/Translate.js';

import { IHeadingConfiguration, IHeadingProps, IHeadingState } from './models/index.js';
import H1 from './styledComponents/H1.js';
import H2 from './styledComponents/H2.js';
import H3 from './styledComponents/H3.js';
import H4 from './styledComponents/H4.js';
import H5 from './styledComponents/H5.js';
import H6 from './styledComponents/H6.js';
import SubTitle from './styledComponents/SubTitle.js';
import Wrapper from './styledComponents/Wrapper.js';
import { HEADING_CATEGORY_KEY, HEADING_COMPONENT_KEY } from './Heading.meta.js';

export class Heading extends ComponentBase<IHeadingProps, IHeadingState, IHeadingConfiguration> {
	categoryKey = HEADING_CATEGORY_KEY;
	componentKey = HEADING_COMPONENT_KEY;

	constructor(props: IHeadingProps) {
		super(props);
	}

	static defaultProps: IHeadingProps = {
		id: undefined,
		title: undefined,
		subTitle: undefined,
		level: 1,
	};

	renderTitle() {
		const { title, level, id: idFromConfig, children } = this.props;
		const id = idFromConfig || `heading-h${level}-${common.commonUtils.generateGuid()}`;

		let HeadingTag;
		switch (level) {
			case 6:
				HeadingTag = H6;
				break;
			case 5:
				HeadingTag = H5;
				break;
			case 4:
				HeadingTag = H4;
				break;
			case 3:
				HeadingTag = H3;
				break;
			case 2:
				HeadingTag = H2;
				break;
			case 1:
			default:
				HeadingTag = H1;
				break;
		}
		return (
			<HeadingTag id={id}>
				<Translate>{title || children}</Translate>
			</HeadingTag>
		);
	}

	render() {
		const { className, title, subTitle, children } = this.props;

		if (title || subTitle) {
			return (
				<Wrapper className={className}>
					{title && this.renderTitle()}
					{subTitle && (
						<SubTitle>
							<Translate>{subTitle}</Translate>
						</SubTitle>
					)}
				</Wrapper>
			);
		}

		// Option to render children, which allows us to make a heading a link etc.
		if (children) {
			return <Wrapper className={className}>{this.renderTitle()}</Wrapper>;
		}

		return null;
	}
}

export default InjectedStyledComponent(observer(Heading), HEADING_CATEGORY_KEY, HEADING_COMPONENT_KEY);
